module.exports = __webpack_public_path__ + "static/media/Side.29726e3a.jpg";